/**
* GW Conditional Pricing Front-end JS
*/

(function($){

	/*
	 * String.format was deprecated in GF 2.7.1 and will be removed in GF 2.8 in favor of String.prototype.gformFormat.
	 *
	 * As we support older versions of GF, we need to add String.prototype.gformFormat if it doesn't exist.
	 */
	if (!String.prototype.gformFormat) {
		String.prototype.gformFormat = function () {
			var args = arguments;
			return this.replace(/{(\d+)}/g, function (match, number) {
				return typeof args[number] !== 'undefined' ? args[number] : match;
			});
		};
	}

	function gpcpDebounce(func, wait, immediate){
		var timeout, args, context, timestamp, result;
		if (null == wait) wait = 100;

		function later() {
			var last = Date.now() - timestamp;

			if (last < wait && last >= 0) {
				timeout = setTimeout(later, wait - last);
			} else {
				timeout = null;
				if (!immediate) {
					result = func.apply(context, args);
					context = args = null;
				}
			}
		}

		var debounced = function(){
			context = this;
			args = arguments;
			timestamp = Date.now();
			var callNow = immediate && !timeout;
			if (!timeout) timeout = setTimeout(later, wait);
			if (callNow) {
				result = func.apply(context, args);
				context = args = null;
			}

			return result;
		}

		debounced.clear = function() {
			if (timeout) {
				clearTimeout(timeout);
				timeout = null;
			}
		}

		debounced.flush = function() {
			if (timeout) {
				result = func.apply(context, args);
				context = args = null;

				clearTimeout(timeout);
				timeout = null;
			}
		}

		return debounced;
	}


	window.GWConditionalPricing = function( formId, pricingLogic, basePrices, useProductsModule ) {

		var self = this;

		self._formId       = formId;
		self._pricingLogic = pricingLogic;
		self._basePrices   = basePrices;
		self._useProductsModule = useProductsModule === true;

		this.pricingIteration = 0;

		this.init = function() {

			var gwcp         = this,
			formElem         = GWConditionalPricing.getFormElement( this._formId ),
			onChangeSelector = [ 'select', 'input:not( .ginput_total + input ):not( .ginput_total )', 'textarea' ].join( ', ' ),
			onClickSelector  = [ 'input[type="checkbox"]', 'input[type="radio"]', 'input[type="number"]' ].join( ', ' ),
			onKeyUpSelector  = [ 'input[type="text"]', 'input[type="hidden"]', 'input[type="number"]', 'textarea' ].join( ', ' );

			formElem
			.on( 'click', onClickSelector, self.debouncedUpdatePricing)
			.on( 'change', onChangeSelector, self.debouncedUpdatePricing)
			.on( 'keyup', onKeyUpSelector, self.debouncedUpdatePricing);

			gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
				if ( formId != self._formId ) {
					return;
				}

				if ( $( elem ).is( '.ginput_total, .ginput_total + input' ) ) {
					return;
				}

				self.debouncedUpdatePricing();
			} );

			gform.addFilter( 'gform_is_value_match', 'gwcpIsCustomQtyFieldMatch' );

			/*
			 * Preserve add-on state when GF rebuilds the products object. Reading at the latest filter
			 * priority keeps the discount current if coupon state changes during an async update.
			 */
			if (
				self._useProductsModule &&
				window.gform.utils &&
				typeof window.gform.utils.addFilter === 'function'
			) {
				window.gform.utils.addFilter(
					'gform/products/pre_product_change',
					function( data ) {
						if ( data.formId != self._formId || ! data.products ) {
							return data;
						}

						var currentProducts = window.gform.state.get( self._formId, 'products' ) || {};

						if ( data.products.discount === undefined && currentProducts.discount !== undefined ) {
							data.products.discount = currentProducts.discount;
						}

						return data;
					},
					2147483647
				);
			}

			// Trigger price update after conditional logic is processed
			$( document ).on( 'gform_post_conditional_logic', function( e, formId ) {
				if ( parseInt( formId ) === self._formId) {
					self.debouncedUpdatePricing();
				}
			});

			// Capture the GPPA-populated price whenever GPPA (re)populates a field, before a pricing
			// rule can overwrite the input. This fires synchronously as GPPA replaces the field HTML,
			// ahead of our debounced updatePricing(), so the base price input still holds the populated value.
			$( document ).on( 'gppa_updated_batch_fields', function( e, formId, updatedFieldIDs ) {
				if ( parseInt( formId ) === self._formId ) {
					self.captureGPPAPopulatedPrices( updatedFieldIDs );
				}
			});

			// add to form for use with customizations
			formElem.data( 'gwcp', gwcp );

			// Capture the initial, server-rendered GPPA price before applying any pricing rules.
			gwcp.captureGPPAPopulatedPrices( Object.keys( self._pricingLogic ) );

			gwcp.updatePricing();

		};

		GWConditionalPricing.getFormElement = function( formId ) {

			var formElem = $( gform.applyFilters( 'gpcp_form_element', '#gform_wrapper_' + formId ) );

			if ( formElem.length <= 0 ) {
				formElem = $( '#gform_' + formId );
			}

			return formElem;
		};

		self.debouncedUpdatePricing = gpcpDebounce( function() {
			self.updatePricing();
		}, 50);

		this.updatePricing = function( triggerFieldId ) {

			this.ruleCache[formId] = {};

			this.pricingIteration++;

			// if no product ID is passed, loop through all pricing logic
			var updateAllProducts = ! triggerFieldId;

			// Matches found
			var matchesFound = {};

			for ( var productId in this._pricingLogic ) {

				if ( ! this._pricingLogic.hasOwnProperty( productId ) ) {
					continue;
				}

				var pricingLevels = this._pricingLogic[ productId ];

				// This can happen if they delete a product from the form without removing the conditional pricing rules.
				if ( ! pricingLevels || pricingLevels[0] === null ) {
					continue;
				}

				var isProduct = parseInt( productId ) == triggerFieldId,
				isDependency  = this.isDependency( triggerFieldId, pricingLevels );

				if ( ! updateAllProducts && ! isProduct && ! isDependency ) {
					continue;
				}

				// Handle the situation where there is a rule on both a product and a choice. Without this, we can get an infinite loop and the price won't set correctly.
				if ( parseInt( productId ) in matchesFound || productId in matchesFound ) {
					continue;
				}

				for ( var i = 0; i < pricingLevels.length; i++ ) {

					var pricingLevel = pricingLevels[i],
					isMatch          = this.isMatch( this._formId, pricingLevel.conditionalLogic );

					if ( ! isMatch ) {
						continue;
					}

					matchesFound[ productId ] = true;
					GWConditionalPricing.setPrice( productId, pricingLevel.price, this._formId );

					// we only want the first match per product, otherwise, subsequent matches will overwrite the price
					break;
				}

				// if no matching pricing level was found, set back to basePrice
				if ( ! ( parseInt( productId ) in matchesFound ) && ! ( productId in matchesFound ) ) {
					GWConditionalPricing.setPrice( productId, false, this._formId );
				}
			}

			/**
			 * Trigger calculated product recalculation.
			 */
			if ( window.gf_global.gfcalc ) {
				var calcObject = window.gf_global.gfcalc[ formId ];

				if ( calcObject ) {
					calcObject.runCalcs( formId, calcObject.formulaFields );
				}
			}

			/**
			 * Do something after product prices have been updated.
			 *
			 * @since 1.2.13
			 *
			 * @param bool|int triggerFieldId The ID of the field that has triggered the pricing update
			 * @param object GWConditionalPricing Current GWConditionalPricing object.
			 * @param bool|int productId The ID of the product field.
			 *
			 * @see https://gist.github.com/spivurno/aaf3d6a684b418edeeed
			 */
			gform.doAction( 'gpcp_after_update_pricing', triggerFieldId, this, productId );

			if ( this._useProductsModule ) {
				/*
				 * Gravity Forms 3.0 lazy-loads the products module after form init scripts run. On the
				 * initial render it will read the prices we set above when it initializes. For later
				 * updates, refresh its product state and let its state watcher recalculate the total.
				 *
				 * The version gate is deliberate; do not replace it with a feature check on
				 * gform.products. That module has existed since GF 2.9, but the state watcher that
				 * actually writes the total field is new in 3.0, so on 2.9 and 2.10 calling
				 * updateProducts() would update the product state and leave the total stale.
				 */
				if ( window.gform.products && typeof window.gform.products.updateProducts === 'function' ) {
					window.gform.products.updateProducts( this._formId );
				}
			} else {
				gformCalculateTotalPrice( this._formId );
			}

		};

		this.ruleCache = {};

		/**
		 * Based on Gravity Form's gf_get_field_action but includes caching for performance and changes return value to
		 * boolean.
		 *
		 * @param formId
		 * @param conditionalLogic
		 * @return {boolean}
		 */
		this.isMatch = function( formId, conditionalLogic ) {
			if ( ! conditionalLogic) {
				return true;
			}

			if ( ! (formId in this.ruleCache)) {
				this.ruleCache[formId] = {};
			}

			var matches = 0;
			for ( var i = 0; i < conditionalLogic["rules"].length; i ++ ) {
				var rule = $.extend({}, conditionalLogic["rules"][i]);
				rule.value = rule.value.trim();

				/* Format the rule value to the proper number depending on currency. */
				var fieldNumberFormat = gf_get_field_number_format( rule.fieldId, formId, 'value' );

				if( fieldNumberFormat ) {
					rule.value = gf_format_number( rule.value, fieldNumberFormat );
				}

				var ruleStringified = JSON.stringify( rule );
				var inputSelector = '#input_{0}_{1}'.gformFormat( formId, rule['fieldId'] );
				var isHiddenCacheKey = 'is_hidden:' + inputSelector;
				var $field = $( inputSelector );

				if ( !( isHiddenCacheKey in this.ruleCache[formId] ) ) {
					var isRuleFieldHidden = gformIsHidden( $field )
						|| $field.closest( '.gfield' ).attr( 'data-conditional-logic' ) === 'hidden';
					this.ruleCache[formId][isHiddenCacheKey] = isRuleFieldHidden && $field.prop( 'type' ) !== 'hidden';
				}

				// Check if the field is hidden and skip processing altogether if it is
				if ( this.ruleCache[formId][isHiddenCacheKey] ) {
					continue;
				}

				if ( ! (ruleStringified in this.ruleCache[formId])) {
					this.ruleCache[formId][ruleStringified] = gf_is_match( formId, rule );
				}

				if (this.ruleCache[formId][ruleStringified]) {
					matches++;
				}

			}

			var action;
			if ( (conditionalLogic["logicType"] == "all" && matches == conditionalLogic["rules"].length) || (conditionalLogic["logicType"] == "any" && matches > 0) ) {
				action = conditionalLogic["actionType"];
			} else {
				action = conditionalLogic["actionType"] == "show" ? "hide" : "show";
			}

			return action == "show";
		};

		GWConditionalPricing.setPrice = function( productId, price, formId ) {

			var gwcp       = GWConditionalPricing.getFormElement( formId ).data( 'gwcp' ),
			currency       = (typeof gform !== 'undefined' && typeof gform.Currency === 'function') ? new gform.Currency( gf_global['gf_currency_config'] ) : new Currency( gf_global['gf_currency_config'] ),
			fieldId        = parseInt( productId ),
			input          = GWConditionalPricing.getProductInput( productId, formId ),
			isMultiProduct = input.length > 1,
			isReset        = price === false,
			origPrice      = price;

			if ( ! input ) {
				return false;
			}

			var changedInputs = null;

			input.each( function( index ) {

				var input  = $( this ),
				prevValue  = input.val(),
				newValue   = '',
				isSelected = false,
				inputId    = isMultiProduct ? productId + '.' + ( index + 1 ) : productId;

				if ( isReset ) {
					origPrice = gwcp.getOriginalPrice( input, inputId, currency );
				}

				/**
				 * Filter the price about to be set for the given product.
				 *
				 * This filter runs both when the Conditional Pricing is setting the product to a matched pricing level and
				 * when resetting the original price when no pricing level matches.
				 *
				 * @param string|float price The price to be set.
				 * @param object       meta {
				 *     An array of useful meta information about the current price.
				 *
				 *     @type int|string productId The ID of the product for which the price is being set.
				 *     @type bool       isReset   Indicates if the price is being reset to its original value because not pricing rule is matched.
				 *     @type {jQuery}   $input    A jQuery object for the input on which the price is being set.
				 *     @type string     inputId   The ID of the specific input being modified. Only applies to multi-product fields.
				 *     @type object     gwcp      The current GWConditionalPricing object.
				 *     @type {Currency} currency  The current GF Currency object.
				 *     @type int        formId    The current form ID.
				 * }
				 */
				// pass origPrice to prevent multiple manipulations of the "price" in filter functions (js passes by reference)
				price = gform.applyFilters( 'gpcp_price', origPrice, {
					productId: productId,
					isReset:   isReset,
					input:     input,
					inputId:   inputId,
					gwcp:      gwcp,
					currency:  currency,
					formId:    formId
				} );

				// if 'false' is returned, do not set price
				if ( price === false ) {
					return;
				}

				// to be safe, let's always get the price as a number
				// sometimes GF sets it as a currency string or times as a number
				price = currency.toNumber( price );

				if ( input.is( 'option' ) || input.is( ':radio' ) ) {

					// skip any 'choice' that is "empty"
					if ( input.val() == '|' ) {
						return;
					}

					var productName = input.val().substring( 0, input.val().lastIndexOf( '|' ) );

					newValue   = productName + '|' + price;
					isSelected = input.is( ':selected, :checked' );

					input.val( newValue );

				} else {

					newValue   = price;
					isSelected = true;

					input.val( currency.toMoney( price, true ) );

					// single product fields need to be visually updated outside of the hidden input
					var suffix = '_' + gwcp._formId + '_' + fieldId;

					$( 'span#input' + suffix ).text( currency.toMoney( price, true ) );

				}

				// convert previous value to number so we can compare two numbers rather than two currencies
				// UNLESS this is a choice-based value (i.e. "value|price", "First Choice|5").
				if ( prevValue.indexOf( '|' ) == -1 ) {
					prevValue = currency.toNumber( prevValue );
				}

				if ( newValue != prevValue && isSelected ) {
					//input.change();
					if ( changedInputs == null ) {
						changedInputs = input;
					} else {
						changedInputs.add( input );
					}
				}

			} );

			$( changedInputs ).change();

		};

		/**
		* Returns the lowest level HTML element that represents the product. In the case of a multi-product parent,
		* an array of lowest level HTML elements are returned for all "child" products.
		*
		*   select  => option
		*   radio   => input
		*   single  => input
		*
		*/
		GWConditionalPricing.getProductInput = function( productId, formId ) {

			var fieldId = parseInt( productId ),
			suffix      = '_' + formId + '_' + fieldId,
			productId   = productId.toString();

			// check for single product first
			var input = $( '#ginput_base_price' + suffix );

			// if no single product, check if this is a multi-product field (select, radio)
			if ( input.length <= 0 ) {

				var isMultiProductParent = fieldId == productId; // (ie 5 == 5, rather than 5.1 != 5 )
				var inputId              = productId.split( '.' )[1] - 1;

				input = $( '#input' + suffix );

				// If the input is a <ul> (<2.5) or <div> (2.5+), the product is a radio button.
				if ( input.is( 'ul' ) || input.is( 'div' ) ) {
					if ( isMultiProductParent ) {
						input = input.find( 'input[type="radio"]' );
					} else {

						// at some point, GF added the form ID to the choice ID for radio buttons (maybe it was always there... but I don't think so)
						input = input.find( '#choice_' + formId + '_' + fieldId + '_' + inputId );

						// if form ID version is not found, check for choice without form ID
						if ( input.length <= 0 ) {
							input = $( '#input' + suffix + ' #choice_' + fieldId + '_' + inputId );
						}
					}
				}
				// otherwise, assume the product is a select
				else {

					// get all select options (except the placeholder input)
					input = input.find( 'option:not( .gf_placeholder )' );

					if ( ! isMultiProductParent ) {
						input = input.eq( inputId );
					}

				}

			}

			return input.length <= 0 ? false : input;
		};

		this.getFieldIdFromHtmlId = function( id ) {

			if ( ! id ) {
				return false;
			}

			var idBits = id.split( '_' ),
			fieldId    = false;

			// ginput_quantity_1637_25
			if ( idBits[1] == 'quantity' ) {
				//fieldId = 'quantity_' + idBits[idBits.length - 1];
				fieldId = idBits[idBits.length - 1];
			} else if ( idBits[0] == 'choice' || idBits.length == 4 ) {
				fieldId = idBits[ idBits.length - 2 ];
			} else {
				fieldId = idBits[ idBits.length - 1 ];
			}

			return fieldId;
		};

		this.getBasePrice = function( productId ) {
			return this._basePrices[productId];
		};

		/**
		 * Get the price a product input should be reset to when no pricing level matches.
		 *
		 * Prefers the price captured from the rendered field, since GPPA-populated products can have stale or
		 * missing saved prices, causing the product price to be incorrect or reset to $0. Falls back to the
		 * base price from the form definition.
		 *
		 * @param {jQuery}   $input   The product input being reset.
		 * @param {string}   inputId  The ID of the specific input. Only differs from the field ID for multi-product fields.
		 * @param {Currency} currency The current GF Currency object.
		 *
		 * @returns {number} The original price.
		 */
		this.getOriginalPrice = function( $input, inputId, currency ) {

			var isChoice = $input.is( 'option' ) || $input.is( ':radio' );

			/*
			 * Choice-based products (radio, select) capture a price per choice. A field-level price cannot be
			 * used for them as it would apply the selected choice's price to every choice in the field.
			 */
			if ( isChoice ) {
				var capturedChoicePrice = $input.data( 'gpcp-original-price' );

				if ( capturedChoicePrice !== undefined ) {
					return capturedChoicePrice;
				}
			} else {
				var capturedFieldPrice = this.getGPPACapturedPrice( inputId );

				if ( capturedFieldPrice !== false ) {
					return capturedFieldPrice;
				}
			}

			return currency.toNumber( this.getBasePrice( inputId ) );
		};

		/**
		 * Get a product's current quantity without relying on Gravity Forms' deprecated pricing globals.
		 *
		 * On GF 3.0 the products module's state is authoritative. That module is lazy-loaded, though, so
		 * the state is still empty during our first updatePricing() call; that case, and every GF below
		 * 3.0, falls through to a port of GF's own gformGetProductQuantity(). Keep the two paths in sync:
		 * the fallback is what decides the price on the initial render, and the state path decides it from
		 * the first interaction onwards.
		 */
		GWConditionalPricing.getProductQuantity = function( fieldId, formId ) {

			var gwcp = GWConditionalPricing.getFormElement( formId ).data( 'gwcp' );
			var productsState = gwcp && gwcp._useProductsModule && window.gform.state && typeof window.gform.state.get === 'function'
				? window.gform.state.get( formId, 'products' )
				: null;

			if ( productsState && Array.isArray( productsState.products ) ) {
				var product = productsState.products.find( function( item ) {
					return parseInt( item.id, 10 ) === parseInt( fieldId, 10 );
				} );

				// The products module omits products that are unselected or hidden by conditional logic.
				return product ? parseFloat( product.quantity ) || 0 : 0;
			}

			// An unselected product has no quantity.
			if ( ! GWConditionalPricing.isProductSelected( fieldId, formId ) ) {
				return 0;
			}

			var quantity,
				numberFormat,
				quantityInput = $( '#ginput_quantity_' + formId + '_' + fieldId );

			// Since GF 2.5, the Single Product field's built-in quantity input is rendered as
			// #input_{formId}_{fieldId}_1 on the front end. #ginput_quantity_* is only used by the entry
			// detail and form editor renders.
			if ( quantityInput.length <= 0 ) {
				quantityInput = $( '#input_' + formId + '_' + fieldId + '_1' );
			}

			if ( quantityInput.length > 0 ) {

				// A quantity hidden by conditional logic means no product.
				if ( gformIsHidden( quantityInput ) ) {
					return 0;
				}

				quantity = quantityInput.val();

			} else {

				// Fall back to a dedicated Quantity field, if there is one.
				quantityInput = $( '.gfield_quantity_' + formId + '_' + fieldId ).find( ':input' );

				quantity = 1;

				if ( quantityInput.length > 0 ) {
					quantity     = quantityInput.val();
					numberFormat = gf_get_field_number_format( gf_get_input_id_by_html_id( quantityInput.attr( 'id' ) ), formId, 'value' );
				}

			}

			// gf_format_number() resolves the decimal separator from the field's number format and returns
			// a decimal-dot number, which is what GF's own quantity handling does.
			quantity = parseFloat( gf_format_number( quantity, numberFormat ? numberFormat : 'currency' ) );

			return isNaN( quantity ) ? 0 : quantity;
		};

		/**
		 * Port of Gravity Forms' gformIsProductSelected(), which is deprecated in GF 3.0. Only used by
		 * getProductQuantity()'s fallback path; on 3.0 the products module reports selection for us.
		 */
		GWConditionalPricing.isProductSelected = function( fieldId, formId ) {

			var suffix = '_' + formId + '_' + fieldId,
			input      = $( '#ginput_base_price' + suffix + ', .gfield_donation' + suffix + ' input[type="text"], .gfield_product' + suffix + ' .ginput_amount' );

			if ( input.val() && ! gformIsHidden( input ) ) {
				return true;
			}

			input = $( '.gfield_product' + suffix + ' select, .gfield_product' + suffix + ' input:checked, .gfield_donation' + suffix + ' select, .gfield_donation' + suffix + ' input:checked' );

			return !! ( input.val() && ! gformIsHidden( input ) );
		};

		this.isDependency = function( fieldId, pricingLevels ) {

			for ( var i = 0; i < pricingLevels.length; i++ ) {
				for ( var j = 0; j < pricingLevels[ i ].conditionalLogic.rules.length; j++ ) {

					var ruleFieldId = pricingLevels[ i ].conditionalLogic.rules[ j ].fieldId;

					// Note: this will register all inputs changes of a multi-input field as dependencies, even if the ruleFieldId is input specific.
					// We might want to make this more specific in the future.
					if ( parseInt( ruleFieldId ) == parseInt( fieldId ) ) {
						return true;
					} else if ( Number.isNaN( ruleFieldId ) && ruleFieldId.indexOf( 'quantity' ) != -1 && ruleFieldId.split( '_' )[1] == fieldId ) {
						return true;
					}

				}
			}

			return false;
		};

		GWConditionalPricing.hasPlaceholder = function( productId, formId ) {

		};

		/**
		 * Store the rendered price of each product so it can be restored when no pricing rule matches.
		 *
		 * Single product fields are persisted to the field's `gppa-hydrated-value` data store; choice-based
		 * products (radio, select) are persisted per choice as `gpcp-original-price`. Both are read back by
		 * getOriginalPrice(). Reading the price later is unreliable as by then a pricing rule may have
		 * overwritten it with a conditional price.
		 *
		 * @param {Array} fieldIds Field IDs to capture (e.g. those just (re)populated by GPPA).
		 */
		this.captureGPPAPopulatedPrices = function( fieldIds ) {
			var currency = (typeof gform !== 'undefined' && typeof gform.Currency === 'function') ? new gform.Currency( gf_global['gf_currency_config'] ) : new Currency( gf_global['gf_currency_config'] );

			for ( var i = 0; i < fieldIds.length; i++ ) {
				var fieldId    = parseInt( fieldIds[ i ] );
				var $basePrice = $( '#ginput_base_price_' + self._formId + '_' + fieldId );

				// Only single product fields have a base price input.
				if ( $basePrice.length ) {
					$( '#field_' + self._formId + '_' + fieldId ).data( 'gppa-hydrated-value', currency.toNumber( $basePrice.val() ) );
					continue;
				}

				/*
				 * Store each rendered choice's price so it can be restored when no pricing rule matches.
				 * This preserves prices from GPPA-populated choices, which may differ from the saved form choices.
				 */
				var $choices = GWConditionalPricing.getProductInput( fieldId, self._formId );

				if ( ! $choices ) {
					continue;
				}

				$choices.each( function() {

					var $choice = $( this );
					const value = $choice.val();

					if ( ! $choice.is( 'option' ) && ! $choice.is( ':radio' ) ) {
						return;
					}

					if ( typeof value !== 'string' || value.indexOf( '|' ) === -1 ) {
						return;
					}

					// Product values can contain pipes, so the price is always the final segment.
					var choicePrice = currency.toNumber( value.substring( value.lastIndexOf( '|' ) + 1 ) );

					if ( choicePrice === false || isNaN( choicePrice ) ) {
						return;
					}

					$choice.data( 'gpcp-original-price', choicePrice );

				} );
			}
		};

		/**
		 * Get the price captured for a GPPA-populated single product field, if there is one.
		 *
		 * @param {string} productId The product field ID
		 * @returns {number|false} The captured price or false if not found
		 */
		this.getGPPACapturedPrice = function( productId ) {
			// Check if GPPA is available
			if ( ! window.gppaForms || ! window.gppaForms[this._formId] ) {
				return false;
			}

			var gppaForm = window.gppaForms[this._formId];
			var fieldId = parseInt( productId );
			if ( isNaN( fieldId ) ) {
				return false;
			}

			// Only use GPPA fallback when this exact product field is populated by GPPA.
			if (
				! gppaForm.fieldMap ||
				! gppaForm.fieldMap.hasOwnProperty( fieldId.toString() )
			) {
				return false;
			}

			var gppaPopulatedValue = null;

			// Check if field has GPPA hydrated value stored. Zero is a valid populated price.
			var $field = $( '#field_' + this._formId + '_' + fieldId );
			if ( $field.data( 'gppa-hydrated-value' ) !== undefined ) {
				gppaPopulatedValue = $field.data( 'gppa-hydrated-value' );
			}

			// Convert to number and validate
			if ( gppaPopulatedValue !== null && ! isNaN( parseFloat( gppaPopulatedValue ) ) ) {
				return parseFloat( gppaPopulatedValue );
			}

			return false;
		};

		return this.init();
	}

})( jQuery );

function gwcpIsCustomQtyFieldMatch( isMatch, formId, rule ) {

	// check for actual field IDs cheaply
	if ( ! isNaN( parseInt( rule.fieldId ) ) ) {
		return isMatch;
	}

	// check of our quantity_X tag
	var regex = /(quantity)_([0-9]+)/;
	var match = regex.exec( rule.fieldId );
	if ( ! match || match[1] != 'quantity' ) {
		return isMatch;
	}

	var quantity = GWConditionalPricing.getProductQuantity( match[2], formId );

	return gf_matches_operation( quantity + '', rule.value, rule.operator );
}
